import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

const langMapping = {
  'zh-Hant': 'tc'
};
export default function getLanguageFolderName() {
  const lang = getLanguageByPath();
  const langMap = langMapping[lang];
  return langMap || lang;
}
